<template>
  <section id="js-scroll" class="invalid-token-section">
    <Alert :lang="lang" :alertText="alertText"></Alert>
    <p class="margin-top25">
      {{ InvalidToken.description[lang] }}&nbsp;{{ eventName }}
    </p>
    <figure class="app-overview">
      <img
        src="../../../assets/images/app/runkeeper-app-logo.png"
        alt=""
        width="40px"
        height="40px"
      />
      <figcaption class="app-name">ASICS Runkeeper™</figcaption>
    </figure>
    <div class="cooperation-button">
      <PrimaryButton type="button" @click.native="reLink">
        {{ InvalidToken.cooperation[lang] }}
      </PrimaryButton>
    </div>
    <div class="grayout" v-if="isLoading">
      <Loading></Loading>
    </div>
  </section>
</template>

<script>
import Alert from "./Alert";
import Loading from "../../../components/sp/Loading";
import PrimaryButton from "./PrimaryButton";
import InvalidToken from "../../../assets/constants/confirmation/invalid-token/invalid-token";
import { RepositoryFactory } from "../../../api/RepositoryFactory";
export default {
  data() {
    return {
      InvalidToken: InvalidToken,
      isLoading: false,
    };
  },
  mounted() {
    // 要素見えない可能性あるのでスクロール入れる
    const element = document.getElementById("js-scroll");
    element.scrollIntoView({ behavior: "smooth" });
  },
  props: {
    email: {
      type: String,
    },
    appauthid: {
      type: String,
    },
    lang: {
      type: String,
    },
    eventId: {
      type: String,
    },
    eventName: {
      type: String,
    },
  },
  methods: {
    reLink: async function () {
      this.isLoading = true;
      const data = {
        event_id: this.eventId,
        email: this.email,
        app_auth_code: this.appauthid,
        application: "runkeeper",
      };
      try {
        const OauthUserRepository = RepositoryFactory.get("oauth");
        const response = await OauthUserRepository.postRelease(data);
        this.releaseData = response.data;
      } catch (e) {
        console.error(e);
      }
      if (!this.releaseData.count) {
        return;
      }
      const oauthUrl = process.env.RUNKEEPER.OAUTH_URI;
      const clientId = process.env.RUNKEEPER.CLIENT_ID;
      const resType = process.env.RUNKEEPER.RES_TYPE;
      const redirectUrl = process.env.SITE.TMF_REDIRECT_URL;
      location.href = `${oauthUrl}?client_id=${clientId}&response_type=${resType}&redirect_uri=${redirectUrl}?lang=${this.lang}`;
    },
  },
  computed: {
    alertText: function () {
      return "invalid-token";
    },
  },
  components: {
    Alert,
    Loading,
    PrimaryButton,
  },
  name: "InvalidToken",
};
</script>

<style scoped>
.invalid-token-section {
  .app-overview {
    display: flex;
    align-items: center;
    margin: 45px 0 0 0;
    .app-name {
      margin: 0 0 0 10px;
      font-size: 16px;
      font-weight: bold;
    }
  }
  .cooperation-button {
    margin: 12px 0 0 0;
  }
  .grayout {
    width: 100vw;
    height: 100vh;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sp/oauth/InvalidToken.vue